let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gbxN6")).then(() => parcelRequire('em7Y8'));